'use strict';

const $ = jQuery.noConflict();
$(function() {

	const ctaCards = {

		init: function() {
			this.cacheDOM();
		},

		cacheDOM: function() {
			this.$block = $('.js-cta-cards');
		},

	};

	ctaCards.init();
});
